import {FC, memo, MouseEventHandler} from "react";
import {CheckBoxBody, CheckBoxContainer} from "./FileCheckboxStyle";

import checkbox from "../../image/check-button.png"

import {CheckCircleFill} from "react-bootstrap-icons";
import {CheckCircle} from "react-bootstrap-icons";

type FileCheckBoxProps = {
    cheked: boolean,
}
const FileCheckbox: FC<FileCheckBoxProps> = (props) => {

    return (
        <CheckBoxContainer>
            {props.cheked && <>
             <CheckBoxBody/>
             <CheckCircleFill size={30} style={{position: "absolute", top: 0, right: 0, zIndex: 6}}/>
            </>}
        </CheckBoxContainer>

    )
}
export default memo(FileCheckbox)
